/* JHERR · Busca por precio (menú del celular).
   1) Pide a Shopify los relojes del rango con el filtro de precio de la colección.
   2) Si esa consulta no está disponible (por ejemplo, al ver el tema en vista previa
      o si la colección no tiene filtro de precio), lee el catálogo una sola vez y filtra aquí.
   Empieza plegado: se abre al tocar "Busca por precio". El orden sigue al extremo que se mueve.
   El botón "Ver los N relojes" lleva a la vista ?view=precio de la colección y recuerda
   qué relojes vio el cliente: esa página los pone primero, en el mismo orden.
   Nunca muestra un error: en el peor caso deja un botón para ver el rango en la tienda. */
(function () {
  'use strict';
  if (window.__jhPriceFilter) return;
  window.__jhPriceFilter = true;

  var SECTION = 'jherr-price-results';
  var LIMIT = 24;          /* relojes en el carrusel; al final va la tarjeta "Ver más" */
  var GAP = 20;            /* distancia mínima entre los extremos, en soles */
  var MAX_PAGES = 6;       /* respaldo: hasta 1500 productos */
  var catalogCache = {};   /* respaldo: productos por colección */

  function soles(n) { return 'S/ ' + Math.round(n); }
  function price2(n) { return 'S/ ' + (Math.round(n * 100) / 100).toFixed(2); }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function previewParam() {
    var t = window.Shopify && window.Shopify.theme;
    return t && t.id && t.role && t.role !== 'main' ? 'preview_theme_id=' + t.id : '';
  }

  function withParams(base, params) {
    var clean = params.filter(Boolean);
    if (!clean.length) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + clean.join('&');
  }

  /* ---------- Respaldo: catálogo completo de la colección, una sola vez ---------- */
  function loadCatalog(base) {
    var path = base.replace(/\?.*$/, '').replace(/\/$/, '');
    if (catalogCache[path]) return catalogCache[path];
    var all = [];
    function page(n) {
      return fetch(path + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (json) {
          var list = json.products || [];
          list.forEach(function (p) {
            var prices = (p.variants || []).filter(function (v) { return v.available !== false; });
            if (!prices.length) prices = p.variants || [];
            var price = Math.min.apply(null, prices.map(function (v) { return parseFloat(v.price) || 0; }));
            var compare = Math.max.apply(null, prices.map(function (v) { return parseFloat(v.compare_at_price) || 0; }));
            var available = (p.variants || []).some(function (v) { return v.available !== false; });
            if (!isWatch(p.title, p.product_type)) return;
            all.push({
              title: p.title,
              url: '/products/' + p.handle,
              image: p.images && p.images[0] ? p.images[0].src : '',
              price: price,
              compare: compare > price ? compare : 0,
              available: available
            });
          });
          if (list.length === 250 && n < MAX_PAGES) return page(n + 1);
          return all;
        });
    }
    catalogCache[path] = page(1).catch(function (err) { delete catalogCache[path]; throw err; });
    return catalogCache[path];
  }

  /* Igual que snippets/jherr-price-skip.liquid: fuera lo que no es reloj */
  function isWatch(title, type) {
    var t = String(title || '').toLowerCase();
    var k = String(type || '').toLowerCase();
    if (t.indexOf('grabado') !== -1 && t.indexOf('reloj') === -1) return false;
    if (/grabado|servicio|envoltura/.test(k)) return false;
    if (t.indexOf('envoltura') !== -1 || t.indexOf('empaque de regalo') !== -1) return false;
    return true;
  }

  function cardFromCatalog(p) {
    var img = p.image ? p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=260' : '';
    return '<a class="jh-pf-card" href="' + escapeHTML(p.url) + '">' +
      '<span class="jh-pf-img">' + (img ? '<img src="' + escapeHTML(img) + '" alt="' + escapeHTML(p.title) + '" width="130" height="130" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="jh-pf-name">' + escapeHTML(p.title) + '</span>' +
      '<span class="jh-pf-price">' + price2(p.price) + (p.compare ? ' <s>' + price2(p.compare) + '</s>' : '') + '</span></a>';
  }

  function init(root) {
    if (!root || root.__jhReady) return;
    root.__jhReady = true;

    var minInput = root.querySelector('[data-jh-pf-min]');
    var maxInput = root.querySelector('[data-jh-pf-max]');
    var fill = root.querySelector('[data-jh-pf-fill]');
    var minLabel = root.querySelector('[data-jh-pf-min-label]');
    var maxLabel = root.querySelector('[data-jh-pf-max-label]');
    var status = root.querySelector('[data-jh-pf-status]');
    var results = root.querySelector('[data-jh-pf-results]');
    var forButtons = Array.prototype.slice.call(root.querySelectorAll('.jh-pf-for [data-url]'));
    if (!minInput || !maxInput || !results) return;

    var baseUrl = forButtons.length ? forButtons[0].getAttribute('data-url') : '/collections/all';
    var rangeMax = parseInt(maxInput.max, 10) || 2000;
    var rangeKnown = false;
    var mode = 'section'; /* 'section' | 'catalog' */
    var cache = {};
    var controller = null;
    var timer = null;
    var started = false;
    var request = 0;
    var lastMoved = '';  /* 'min' | 'max': el orden sigue al extremo que se movió */

    function values() {
      return { min: parseInt(minInput.value, 10) || 0, max: parseInt(maxInput.value, 10) || rangeMax };
    }

    function rangeText(v) {
      if (v.min <= 0 && v.max >= rangeMax) return '';
      if (v.min <= 0) return 'hasta ' + soles(v.max);
      if (v.max >= rangeMax) return 'desde ' + soles(v.min);
      return 'de ' + soles(v.min) + ' a ' + soles(v.max);
    }

    function paint() {
      var v = values();
      if (fill) {
        fill.style.left = (v.min / rangeMax) * 100 + '%';
        fill.style.right = (100 - (v.max / rangeMax) * 100) + '%';
      }
      if (minLabel) minLabel.textContent = soles(v.min);
      if (maxLabel) maxLabel.textContent = v.max >= rangeMax ? soles(rangeMax) + ' o más' : soles(v.max);
      /* Si los dos extremos se juntan arriba, el mínimo queda encima para poder moverlo */
      minInput.style.zIndex = v.min > rangeMax - GAP * 3 ? 5 : 3;
    }

    /* Tarjeta final del carrusel: lleva a la colección con este mismo rango */
    function moreCard(count, shown) {
      if (!count || count <= shown) return '';
      return '<a class="jh-pf-more" href="' + linkUrl(values()) + '" data-jh-pf-more>' +
        '<span class="jh-pf-more__circle" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>' +
        '<span class="jh-pf-more__label">Ver más</span>' +
        '<span class="jh-pf-more__sub">' + count + ' relojes en total</span></a>';
    }

    function setRangeMax(amount) {
      var top = Math.ceil(amount / 50) * 50;
      if (!top || top < 100) return;
      rangeKnown = true;
      if (top === rangeMax) return;
      var wasAtTop = parseInt(maxInput.value, 10) >= rangeMax;
      rangeMax = top;
      minInput.max = maxInput.max = String(rangeMax);
      if (wasAtTop || parseInt(maxInput.value, 10) > rangeMax) maxInput.value = String(rangeMax);
      if (parseInt(minInput.value, 10) > rangeMax - GAP) minInput.value = String(Math.max(0, rangeMax - GAP));
      paint();
    }

    /* Orden: con todo el rango, los más vendidos; al bajar el máximo, primero los más cercanos
       a ese tope (de mayor a menor); al subir el mínimo, primero los más cercanos a ese piso.
       Así los relojes cambian a la vista apenas se mueve un extremo. */
    function sortKey(v) {
      if (v.min <= 0 && v.max >= rangeMax) return 'best-selling';
      if (lastMoved === 'min' || (v.max >= rangeMax && v.min > 0)) return 'price-ascending';
      return 'price-descending';
    }

    function filterUrl(v, extra) {
      return withParams(baseUrl, [
        v.min > 0 ? 'filter.v.price.gte=' + v.min : '',
        v.max < rangeMax ? 'filter.v.price.lte=' + v.max : '',
        'sort_by=' + sortKey(v)
      ].concat(extra || []));
    }

    /* Destino del botón: la vista de precio de la colección (plantilla collection.precio) */
    function linkUrl(v) {
      return filterUrl(v, ['view=precio']);
    }

    function render(data, v) {
      var range = rangeText(v);
      results.innerHTML = (data.html || '') + moreCard(data.count, ((data.html || "").match(/class="jh-pf-card"/g) || []).length);
      results.scrollLeft = 0;
      results.classList.toggle('is-empty', !data.html);
      root.classList.remove('is-loading');

      if (status) {
        if (data.count === 0) {
          status.textContent = 'No hay relojes ' + (range || 'en este rango') + '. Mueve un poco los extremos.';
        } else if (typeof data.count === 'number') {
          var order = { 'best-selling': ' · primero los más vendidos', 'price-descending': ' · de mayor a menor precio', 'price-ascending': ' · de menor a mayor precio' }[data.sort || ''] || '';
          status.textContent = data.count + (data.count === 1 ? ' reloj ' : ' relojes ') + (range ? range : 'en total') + order;
        } else {
          status.textContent = 'Mira los relojes ' + (range || 'de todos los precios') + ' en la tienda.';
        }
      }
    }

    function fromSection(v, signal) {
      var sort = sortKey(v);
      return fetch(filterUrl(v, ['section_id=' + SECTION, previewParam()]), { signal: signal, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
        .then(function (text) {
          var box = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-jh-price-results]');
          if (!box || box.getAttribute('data-has-price-filter') !== 'true') throw new Error('sin-filtro');
          var max = parseInt(box.getAttribute('data-range-max'), 10);
          if (max) setRangeMax(max / 100);
          return { html: box.innerHTML.trim(), count: parseInt(box.getAttribute('data-count'), 10) || 0, sort: sort };
        });
    }

    function fromCatalog(v) {
      var asked = sortKey(v);
      return loadCatalog(baseUrl).then(function (list) {
        if (!rangeKnown && list.length) {
          setRangeMax(Math.max.apply(null, list.map(function (p) { return p.price; })));
          v = values();
        }
        var matches = list.filter(function (p) {
          return p.available && p.price >= v.min && (v.max >= rangeMax || p.price <= v.max);
        });
        var order = asked;
        if (order === 'price-ascending') matches.sort(function (a, b) { return a.price - b.price; });
        if (order === 'price-descending') matches.sort(function (a, b) { return b.price - a.price; });
        return { html: matches.slice(0, LIMIT).map(cardFromCatalog).join(''), count: matches.length, sort: order === 'best-selling' ? '' : order };
      });
    }

    function load() {
      var v = values();
      var key = baseUrl + '|' + v.min + '|' + v.max + '|' + sortKey(v);
      if (cache[key]) { render(cache[key], v); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      var mine = ++request;
      root.classList.add('is-loading');

      var job = mode === 'catalog'
        ? fromCatalog(v)
        : fromSection(v, signal).catch(function (err) {
            if (err && err.name === 'AbortError') throw err;
            mode = 'catalog';
            return fromCatalog(values());
          });

      job.then(function (data) {
        if (mine !== request) return;
        cache[key] = data;
        render(data, values());
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (mine !== request) return;
        render({ html: '', count: null }, values());
      });
    }

    function schedule() {
      paint();
      clearTimeout(timer);
      timer = setTimeout(load, mode === 'catalog' ? 60 : 260);
    }

    minInput.addEventListener('input', function () {
      lastMoved = 'min';
      var max = parseInt(maxInput.value, 10);
      if (parseInt(minInput.value, 10) > max - GAP) minInput.value = String(Math.max(0, max - GAP));
      schedule();
    });
    maxInput.addEventListener('input', function () {
      lastMoved = 'max';
      var min = parseInt(minInput.value, 10);
      if (parseInt(maxInput.value, 10) < min + GAP) maxInput.value = String(Math.min(rangeMax, min + GAP));
      schedule();
    });

    forButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-checked') === 'true') return;
        forButtons.forEach(function (b) { b.setAttribute('aria-checked', String(b === btn)); });
        baseUrl = btn.getAttribute('data-url');
        clearTimeout(timer);
        load();
      });
    });

    /* "Ver más": rango exacto de ese momento y recuerda qué relojes vio el cliente,
       para que la colección los muestre primero, en ese orden */
    results.addEventListener('click', function (event) {
      var more = event.target.closest && event.target.closest('[data-jh-pf-more]');
      if (!more) return;
      more.href = linkUrl(values());
      try {
        var seen = Array.prototype.map.call(results.querySelectorAll('.jh-pf-card'), function (a) {
          var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          return m ? m[1] : '';
        }).filter(Boolean);
        sessionStorage.setItem('jhPriceSeen', JSON.stringify({ url: more.getAttribute('href'), handles: seen, at: Date.now() }));
      } catch (e) {}
    });

    function start() {
      if (started) return;
      started = true;
      paint();
      load();
    }

    /* Plegable (snippets/jherr-menu-price.liquid): solo carga relojes cuando el cliente lo abre.
       El abrir/cerrar y el arrastre de la barra están en jherr-price-filter-ui.js */
    if (root.hasAttribute('data-jh-pf-collapsible')) {
      root.addEventListener('jh-pf:open', start);
      if (root.classList.contains('is-open')) start();
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { start(); io.disconnect(); }
      });
      io.observe(root);
    } else {
      start();
    }
    paint();
  }

  function boot() { document.querySelectorAll('[data-jh-price-filter]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();